// src/webideal-recruit/pages/Pipeline.jsx

import React, { useState, useEffect } from "react";
import { DragDropContext } from "@hello-pangea/dnd";

// FIXED PATH, must be relative, not alias
import PipelineColumn from "../components/pipeline/PipelineColumn.jsx";

import { backendApi } from "@/api/backendApi";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue
} from "@/components/ui/select";
import { Search } from "lucide-react";

export default function Pipeline() {
  const [applications, setApplications] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState("");

  // Pipeline stages
  const stages = [
    { key: "new", label: "New" },
    { key: "screening", label: "Screening" },
    { key: "interview", label: "Interview" },
    { key: "technical", label: "Technical" },
    { key: "offer", label: "Offer" }
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const apps = await backendApi.entities.Application.list();
    const jobs = await backendApi.entities.Job.list();

    setApplications(apps);
    setJobs(jobs);

    // Derive candidates directly from the populated applications
    const uniqueCandidates = [];
    apps.forEach(app => {
      if (app.applicant && !uniqueCandidates.find(c => c.id === app.applicant._id)) {
        uniqueCandidates.push({ id: app.applicant._id, ...app.applicant });
      }
    });
    setCandidates(uniqueCandidates);
  };

  const filteredApps = applications.filter(app => {
    const candidateName = app.applicant?.full_name || "Unknown";
    return candidateName.toLowerCase().includes(search.toLowerCase());
  });

  const groupedByStage = stages.reduce((acc, s) => {
    acc[s.key] = filteredApps.filter(a => a.status === s.key || (!a.status && s.key === "new") || (a.status === "pending" && s.key === "new"));
    return acc;
  }, {});

  // DRAG END
  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const appId = result.draggableId;
    const newStage = result.destination.droppableId;

    await backendApi.entities.Application.update(appId, { stage: newStage });

    loadData();
  };

  return (
    <div className="space-y-8">

      {/* HEADER */}
      <div>
        <h1 className="text-3xl font-bold text-slate-900">Hiring Pipeline</h1>
        <p className="text-slate-500 mt-1">
          Drag and drop candidates through stages
        </p>
      </div>

      {/* FILTERS */}
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input
            placeholder="Search candidates..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-10 bg-white border-slate-200 rounded-xl"
          />
        </div>

        <Select>
          <SelectTrigger className="w-40 bg-white border-slate-200 rounded-xl">
            <SelectValue placeholder="All Jobs" />
          </SelectTrigger>

          <SelectContent>
            <SelectItem value="all">All Jobs</SelectItem>
            {jobs.map((job) => (
              <SelectItem key={job.id} value={job.id}>
                {job.title}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* PIPELINE */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className="flex gap-6 overflow-x-auto pb-6">
          {stages.map((stage) => (
            <PipelineColumn
              key={stage.key}
              stage={stage}
              applications={groupedByStage[stage.key] || []}
              candidates={candidates}
              jobs={jobs}
              onCardClick={() => { }}
            />
          ))}
        </div>
      </DragDropContext>
    </div>
  );
}
